<app-loader *ngIf="showLoader"></app-loader>
<div *ngIf="!showLoader">
  <!-- Main content comes first in DOM for proper reading order -->
  <main class="login-5paisa">
    <div class="row">
      <div class="text-center login-mobile-view">
        <div class="logo_wrap">
          <h1>Welcome to</h1>
          <a
            href="https://www.5paisa.com"
            target="_blank"
            title="5Paisa"
            aria-label="5Paisa"
          >
            <img
              *ngIf="isChecked == false"
              src="https://images.5paisa.com/login/5paisalogonew.svg"
              class="img-responsive logo-img"
              alt="5Paisa company logo"
            />

            <!-- For Dark Theme  -->
            <img
              *ngIf="isChecked == true"
              src="https://images.5paisa.com/login/5PaisaDarkLogo.svg"
              class="img-responsive logo-img"
              alt="5Paisa company logo"
            />
          </a>
        </div>
      </div>
      <div class="col-6 box-left">
        <div class="box_wrap text-center">
          <div
            class="logo_wrap"
            #carouselContainer
            [attr.aria-live]="isCarouselPlaying ? 'polite' : 'off'"
            role="group"
            aria-roledescription="carousel"
          >
            <h1>Welcome to</h1>
            <a href="https://www.5paisa.com" target="_blank" title="5Paisa">
              <img
                *ngIf="isChecked == false"
                src="https://images.5paisa.com/login/5paisalogonew.svg"
                class="img-responsive logo-img"
                alt="5Paisa company logo"
              />

              <!-- For Dark Theme  -->
              <img
                *ngIf="isChecked == true"
                src="https://images.5paisa.com/login/5PaisaDarkLogo.svg"
                class="img-responsive logo-img"
                alt="5Paisa company logo"
              />
            </a>

            <img
              *ngIf="isChecked == false"
              src="https://images.5paisa.com/login/login-banner.gif"
              class="animatedBanner"
              alt="Illustration of a glowing light representing financial growth"
            />
            <!-- For Dark Theme banner  -->
            <img
              *ngIf="isChecked == true"
              src="https://images.5paisa.com/SPOT/login/dark-login-banner.gif"
              class="animatedBanner"
              alt="Illustration of a glowing light representing financial growth"
            />
            <owl-carousel-o
              #carouselRef
              [options]="customOptions"
              (initialized)="updateAccessibility($event)"
              (translated)="updateAccessibility($event)"
            >
              <ng-template
                carouselSlide
                *ngFor="let slide of slides; let i = index"
                [id]="'slide-' + slide.id"
              >
                <div
                  role="group"
                  [attr.aria-roledescription]="'slide'"
                  [attr.aria-hidden]="!slide.isActive"
                >
                  <p class="carousel-slide-content">
                    {{ slide.content }}
                  </p>
                </div>
              </ng-template>
            </owl-carousel-o>
          </div>
        </div>
      </div>

      <div class="col-6 box-right">
        <div class="align-items-center justify-content-center d-flex h-100">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </main>

  <!-- Theme switch moved after main content for correct reading/tab order -->
  <header id="app-cover" class="app-cover">
    <div class="row">
      <div class="toggle-button-cover">
        <div class="button-cover">
          <div class="theme-switch">
            <div class="themeLabel">
              <span>Theme</span>
            </div>
            <div class="button r" id="button-1">
              <input
                type="checkbox"
                [checked]="isChecked"
                [attr.aria-checked]="isChecked"
                class="checkbox"
                (click)="isChangedtheme()"
                role="switch"
                aria-label="Toggle dark mode"
                tabindex="0"
              />
              <div class="knobs"></div>
              <div class="layer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <footer class="navigation--footer footer">
    <div class="container">
      <p class="navigation--footer-text">
        SEBI Registration Number : INZ000010231 | AMFI REGN No.: ARN-104096 |
        CIN : L67190MH2007PLC289249
      </p>
      <ul class="navigation--footer-link" role="list">
        <li role="listitem">
          <a href="https://www.5paisa.com/about-us" target="_blank">About Us</a>
        </li>
        <li role="listitem">
          <a href="https://www.5paisa.com/privacy-policy" target="_blank"
            >Privacy Policy</a
          >
        </li>
        <li role="listitem">
          <a href="https://www.5paisa.com/disclaimer" target="_blank"
            >Disclaimer</a
          >
        </li>
        <li role="listitem">
          <a href="https://www.nseindia.com/" target="_blank">NSE</a>
        </li>
        <li role="listitem">
          <a href="https://www.bseindia.com/" target="_blank">BSE</a>
        </li>
        <li role="listitem">
          <a href="https://www.mcxindia.com/" target="_blank">MCX</a>
        </li>
        <li role="listitem">
          <a href="https://www.sebi.gov.in/" target="_blank">SEBI</a>
        </li>
        <li role="listitem">
          <a href="https://scores.gov.in/scores/Welcome.html" target="_blank"
            >SEBI Scores</a
          >
        </li>
        <li role="listitem">
          <a href="https://rbi.org.in/" target="_blank">RBI</a>
        </li>
      </ul>
      <p class="navigation--footer-nse">
        NSE Member ID : 14300 | BSE Clg No : 6363 | MCX Member ID : 55945
      </p>
      <p class="navigation--footer-text">
        Copyright 2026 5paisa Capital Ltd. All Rights Reserved.
      </p>
    </div>

    <div id="back-to-top" class="hide">
      <img
        src="https://images.5paisa.com/login/up-arrow.png"
        alt="Go to 5paisa top"
      />
    </div>
  </footer>
</div>
